<template>
  <form class="vr360-app-main__stream-edit vr360-flex-column" @submit.prevent="submitForm">

    <app-textarea v-model="stream.title.val"
                  :value="stream.title.val"
                  :placeholder="'Stream name'"
                  :errorMessage="'message'"
                  :showErrorMessage="false" />

    <app-textarea v-model="stream.description.val"
                  :value="stream.description.val"
                  :placeholder="'Stream name'"
                  :errorMessage="'message'"
                  :showErrorMessage="false" />

    <div class="vr360-app-main__stream-edit__checkbox">
      <p class="vr360-text-caption vr360-text-gray-3">Private</p>
      <label class="vr360-checkbox">
        <input type="checkbox" v-model="stream.private.val">
        <span></span>
      </label>
    </div>

    <div class="vr360-app-main__stream-edit__btns">
      <button type="submit" class="vr360-btn" :disabled="!isDisabled">
        <span>Save changes</span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import appTextarea from "../partials/TextArea";

export default {
  name: "editStream",
  components: {
    appTextarea
  },
  data() {
    return {
      submit: false,
      stream: {
        title: {
          val: "",
          error: ""
        },
        description: {
          val: "",
          error: ""
        },
        private: {
          val: "",
          error: ""
        }
      }
    };
  },
  created() {
    if (this.currentStream.id) {
      this.getToEdit(this.currentStream);
    } else {
      this.getStream(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions({
      update: "stream/updateStream",
      getStream: "stream/fetchStream",
      showNotification: "showNotification"
    }),

    submitForm() {
      if (!this.submit) {
        this.submit = true;
        Object.keys(this.stream).map( item => this.stream[item] = this.stream[item].val );

        const updated = { ...this.currentStream, ...this.stream };

        this.update({ playload: this.stream, id: this.$route.params.id,  updated });
      }
    },
    handlerBack() {
      this.$router.go(-1);
    },
    getToEdit(val) {
      if (!this.submit) {
        for (var key of Object.keys(this.stream)) {
          if (this.stream[key]) this.stream[key].val = val[key];
        }
      }
    }
  },
  watch: {
    currentStream(val) {
      this.getToEdit(val);
    }
  },
  computed: {
    ...mapGetters({
      currentStream: "stream/currentStream"
    }),
    isDisabled() {
      return this.currentStream &&
        (this.stream.title.val !== this.currentStream.title && !this.stream.title.error) ||
        (this.stream.description.val !== this.currentStream.description && !this.stream.description.error) ||
        (this.stream.private.val !== this.currentStream.private && !this.stream.private.error)
    }
  }
};
</script>

<style lang="scss">
</style>
